import { render, staticRenderFns } from "./bargeForm.vue?vue&type=template&id=ab1ddf7e&scoped=true&"
import script from "./bargeForm.vue?vue&type=script&lang=js&"
export * from "./bargeForm.vue?vue&type=script&lang=js&"
import style0 from "./bargeForm.vue?vue&type=style&index=0&id=ab1ddf7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1ddf7e",
  null
  
)

export default component.exports